// Centralized site metrics for consistent display across components
export default [
  {
    value: "1000+",
    label: "Devices Renewed",
    description: "Hardware items successfully recycled and repurposed",
    icon: "fa-recycle"
  },
  {
    value: "100%",
    label: "Renewable Energy",
    description: "All operations powered by renewable energy",
    icon: "fa-leaf"
  },
  {
    value: "10+",
    label: "Partner Organizations",
    description: "Organizations collaborating on sustainable computing",
    icon: "fa-handshake"
  },
  {
    value: "5000+",
    label: "Students Supported",
    description: "Students benefiting from our computing solutions",
    icon: "fa-users"
  }
];
